import React from 'react'
import { Icon } from 'antd'
import '../../../styles/work_stage.css'


export default {
	"fields": [
		[
			{
				"title": "Nome",
				"key": "name",
				"type": "text",
				"element-attr": {
					required: true,
					prefix: <Icon type="tags" />
				}
			},
			{
				"title": "Status comercial",
				"key": "status",
				"type": "text",
				"element-attr": {
					required: true,
				}
			},
		]
	],
	submit: {
		collection: "PrevisionBuy"
	},
	className: "config-component",
	schema: [
		{
			title: "Nome",
			key: "name",
			dataIndex: "name",
			type: "text",
			className: "name"
		},
		{
			title: "Status comercial",
			key: "status",
			dataIndex: "status",
			type: "text",
			className: "name"
		}
	],
	"title-navigation": <div><Icon type="calendar" /> Previsão de compra</div>,
	"title-module": "Previsão de compra",
	"module": "PrevisionBuy",
	"router-base": "/panel/previsao-compra"
}